/**
 * LoadingOverlay – floating loader sa overlayem
 *
 * Prikazuje se na sredini ekrana sa tamnom pozadinom i spinnerom;
 * opciono: naslov, poruka, lista koraka. Koristi se za full-screen učitavanje (npr. pri loginu).
 */
import React, { useId } from 'react';
import { Oval } from 'react-loader-spinner';
import './LoadingOverlay.css';

// ---------- Komponenta ----------
const LoadingOverlay = ({ 
  isLoading = true, 
  title = 'Учитавање...',
  message = null,
  steps = [],
  className = '',
}) => {
  const titleId = useId();
  
  if (!isLoading) return null;

  const rootClassName = ['loading-overlay', className].filter(Boolean).join(' ');

  return (
    <div 
      className={rootClassName}
      role="dialog" 
      aria-live="polite" 
      aria-busy="true"
      aria-label={title || 'Учитавање'}
      aria-labelledby={titleId}
    >
      <div className="loading-overlay-content">
        <div className="loading-spinner-wrapper">
          <Oval
            height={100}
            width={100}
            color="#4357a18a"
            secondaryColor="#C0C0C0"
            strokeWidth={3}
            strokeWidthSecondary={3}
            visible={true}
            ariaLabel="oval-loading"
          />
        </div>
        
        {title && (
          <h2 id={titleId} className="loading-title">
            {title}
          </h2>
        )}
        
        {message && (
          <p className="loading-message">
            {message}
          </p>
        )}
        
        {steps && steps.length > 0 && (
          <div className="loading-steps">
            {steps.map((step, index) => (
              <p key={index} className="loading-step">
                {step}
              </p>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingOverlay;
